// extracted by mini-css-extract-plugin
module.exports = {"asosFocus":"_1m9N9e_","burger":"_387JN2Z _1m9N9e_","burger__hidden":"_2CZGxSY"};